import { _assert, _isObject } from '@naturalcycles/js-lib';
import { cookieService } from './cookie.service';
class UtmService {
    /**
     * Reconciles query param utms and cookie utms and returns them.
     * Attention: Will throw if the utms cookie value is not valid json.
     */
    refresh() {
        const queryParamUtms = this.getQueryParamUtms();
        const cookieUtms = this.getCookieUtms();
        return this.reconcile(queryParamUtms, cookieUtms);
    }
    /**
     * Returns every current utm_* url query param as key value pairs
     */
    getQueryParamUtms() {
        const queryParams = new URLSearchParams(globalThis.location.search);
        const entries = [...queryParams.entries()];
        const filteredEntries = entries.filter(([key, value]) => {
            return key.startsWith('utm_') && value !== undefined && value !== null && value !== '';
        });
        return Object.fromEntries(filteredEntries);
    }
    /**
     * Returns utms from cookies
     */
    getCookieUtms() {
        const result = JSON.parse(cookieService.getCookie('utms') || '{}');
        _assert(_isObject(result), `parsed utms cookie has wrong type: ${typeof result}`);
        return result;
    }
    /**
     * Set utms cookies with NC utms TTL rules
     */
    setCookieUtms(utms) {
        _assert(_isObject(utms), `can't set utms cookie, input has wrong type: ${typeof utms}`);
        cookieService.setCookie('utms', JSON.stringify(utms), 30);
    }
    /**
     * Reconciles query param utms with cookie utms, letting query param utms overwrite any preexisting cookie utms.
     * If queryParamUtms exists, the cookie TTL is reset.
     */
    reconcile(queryParamUtms, cookieUtms) {
        _assert(_isObject(queryParamUtms), `queryParamUtms has wrong type: ${typeof queryParamUtms}`);
        _assert(_isObject(cookieUtms), `cookieUtms has wrong type: ${typeof cookieUtms}`);
        if (!Object.keys(queryParamUtms).length)
            return cookieUtms;
        const updatedUtms = { ...cookieUtms, ...queryParamUtms };
        this.setCookieUtms(updatedUtms);
        return updatedUtms;
    }
}
export const utmService = new UtmService();
